import { DAEMON_URL } from "../config";
import { HttpError } from "./errors";

export type MeResponse = {
  email: string;
  role: "admin" | "member";
  projects: Array<{ id: string; name: string }>;
  authMode: "cloudflare_access" | "bearer_dev";
  signOutUrl: string | null;
  requirePasswordChange?: boolean;
};

export async function getMe(signal?: AbortSignal): Promise<MeResponse> {
  const url = `${DAEMON_URL}/me`;
  const init: RequestInit = {
    method: "GET",
    headers: { "Accept": "application/json" },
    credentials: "include",
    signal,
  };
  let res: Response;
  try {
    res = await fetch(url, init);
  } catch (e) {
    throw new Error(`network error: ${(e as Error).message}`);
  }
  if (res.status === 401) throw new HttpError(401, "unauthorized");
  if (!res.ok) throw new HttpError(res.status, `http ${res.status}`);
  return (await res.json()) as MeResponse;
}
